<template>
  <div v-show="visible" class="lab-modal-overlay">
    <div class="lab-modal-content">
      <h1 class="lab-modal-title">{{ $t('「EMARF for Owners（β 版）」利用規約') }}</h1>

      <button class="lab-modal-close" @click="$emit('close')" :aria-label="$t('閉じる')">&times;</button>

      	<div class="lab-modal-scroll" >
          <iframe 
          ref="termsFrame" 
          style="width:100%;height:50vh;border:none;"
          @load="removeIframePadding"
          >
        </iframe>
        </div>

      <!-- <div class="lab-modal-scroll">        
          <iframe
            ref="termsFrame"
            v-if="visible"
            src="/documents/EMARF_for_Owners_β版_利用規約draft_250519.pdf#toolbar=0&zoom=80"
            style="width:100%;height:50vh;border:none;"
            
            title="利用規約"
            
          ></iframe>
        <div v-else>
          <div class = "lab-modal-text">
          <p>To use LAB MODE, please make sure you agree with <a href='/static/documents/EMARF_TOS_V200.pdf' target='_blank'>our terms of service</a>. <br> 
          LAB MODEを利用するには<a href='/static/documents/EMARF_TOS_V200.pdf' target='_blank'>利用規約</a>に同意して頂く必要があります。</p>
        </div >
      </div>
      </div> -->

      <div class="lab-modal-checkbox">
        <input id='terms' type='checkbox' v-model='boxChecked' />
        <label for="terms">{{ $t('利用規約に同意する') }}</label>
      </div>

      <div class = "lab-modal-buttons">
        <!-- <button class="lab-modal-button cancel" @click="$emit('close')">キャンセル</button> -->
        <button 
        class="lab-modal-button"
        :class="{'not-checked': !boxChecked}" 
        :disabled="!boxChecked"
        @click="$emit('checked')"
        >{{ $t('次に進む') }}</button>
      </div>
    </div>

    </div>
</template>

<script>
import termsHtmlJa from '!!raw-loader!../assets/documents/EMARF_for_Owners_β版_利用規約draft_250519.html';
import termsHtmlEn from '!!raw-loader!../assets/documents/EMARF_for_Owners_Beta_Terms_of_Use_EN_260526.html';
export default {
  name: "TermsAgreement",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      boxChecked: false,
    };
  },
  computed: {
    termsHtml () {
      return this.$lang === 'en' ? termsHtmlEn : termsHtmlJa;
    }
  },
  watch: {
    termsHtml () {
      this.writeTerms();
    },
    visible (newVal) {
      if (newVal) {
        this.$nextTick(() => this.writeTerms());
      }
    }
  },
  mounted() {
    this.writeTerms();
  },
  methods: {
    writeTerms () {
      if (this.$refs.termsFrame) {
        const doc = this.$refs.termsFrame.contentDocument || this.$refs.termsFrame.contentWindow.document;
        doc.open();
        doc.write(this.termsHtml);
        doc.close();
      }
    },
    removeIframePadding() {

      const iframe = this.$refs.termsFrame;
      if (iframe && iframe.contentWindow) {

        try {
          const doc = iframe.contentDocument || iframe.contentWindow.document;
          const style = doc.createElement('style');
          style.innerHTML = `
          html, body {
            background-color: rgb(236,236,236); !important;
            color: red !important;
            padding: 12px !important;
            margin: 0 !important;
          }
          .c2{
            background-color: rgb(236,236,236); !important;

          }
          * {
            box-sizing: border-box !important;
          }
        `;
          doc.head.appendChild(style);

        } catch (e) {
          // Cross-origin: cannot access

        }
      }
    },

  }

};
</script>

<style scoped>
.lab-modal-overlay {
  position: fixed;
  z-index: 9999;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.1);  
  color: black;
  display: flex; align-items: center; justify-content: center;
}
.lab-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
  color: #888;
  z-index: 10000;
  padding: 0;
  transition: color 0.2s;
}
.lab-modal-close:hover {
  color: white;
}
.lab-modal-content {
  position: relative;
  background: rgba(53, 56, 59, 0.9);
  padding: 32px 24px 24px 24px;
  border-radius: 8px;
  max-width: 600px;
  width: 90vw;
  /* height: 60vh; */
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 8px;
}
.lab-modal-title {
  position: relative;
  text-align: center;
  /* background: #ccc; */
  color: white;
  margin: 0px 24px 24px 24px;
  font-size: 1.5em;
  font-weight: bold;

  padding: 16px 16px;
  border-radius: 4px;
}
.lab-modal-scroll {
  flex: 1 1 auto;
  overflow: auto;
  max-width: 150%;
  margin-bottom: 24px;
  white-space: pre-line;
  /* padding: 24px; */
  background: rgb(236,236,236);
  /* border: 1px solid #333; */
  /* line-height: 1.5; */
}
.lab-modal-text {
  flex: 1 1 auto;
  max-width: 100%;
  max-height: 75vh;
  margin-bottom: 24px;
  white-space: pre-line;
}
.lab-modal-checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4px 0;
  gap: 8px;
  color: white;
  font-weight: bold;
}
.lab-modal-buttons {
  display: flex;
  justify-content: center;
  gap: 16px; /* space between buttons */
  margin-top: 16px;
}
.lab-modal-button {
  align-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 36px;
  border-radius: 2px;
  padding: 12px 12px;
  font-size: 1.1em;
  font-weight: bold;
  background: white;
  color: #333;
  border: none;
  cursor: pointer;
}
.lab-modal-button.cancel {
  background: #ccc;
  color: #333;
}
.lab-modal-button.not-checked {
  background: #ccc;
  color: #333;
  cursor: not-allowed;
}


</style>


// WEBPACK FOOTER //
// src/components/TermsAgreement.vue